export class PaymentPlanInstalment {
	constructor(
		public id: number,
		public amount: number,
		public due_date: Date,
	) {}
}
